import React from 'react';
import { connect } from 'react-redux';
import { toggle, update } from '../Actions/Cart.action';
import MiniCartDrawer from '../Components/MiniCart';

const MiniCartContainer = (props) => (
  <>
    <MiniCartDrawer {...props} />
  </>
);

const mapStateToProps = (state) => {
  const { cart } = state;
  return {
    ...cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggle: () => dispatch(toggle()),
    update: (rowSystemId, quantity) => dispatch(update(rowSystemId, quantity)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer);
